import { useEffect } from "react";
import { isIOS, isMacOs } from "react-device-detect";

const SevricePlans = () => {
  useEffect(() => {
    setTimeout(() => {
      if (isIOS || isMacOs) {
        window.open(
          "https://apps.apple.com/us/app/tip-app-mobile/id1579469134",
          "_self"
        );
      } else {
        window.open(
          "https://play.google.com/store/apps/details?id=com.tipapp",
          "_self"
        );
      }
    }, 3000);
  }, []);
  return (
    <div className="w-full h-full flex justify-center items-center">
      Loading...
    </div>
  );
};

export default SevricePlans;
